import gql from 'graphql-tag';

const updateBadgingBlacklistMutation = gql`
  mutation UpdateBadgingBlacklist($input: UpdateBadgingBlacklistInput!) {
    updateBadgingBlacklist(input: $input) {
      success
      errors
      badgingBlacklistEntry {
        id
        sellerNumber
        vin
        expirationDate
        notes
        status
        createdAt
      }
    }
  }
`;

export default updateBadgingBlacklistMutation;
